export const GET_COMPOSER = 'app/Composer/GET_COMPOSER';
export const GET_UPCOMMING_PRODUCTIONS = 'app/Composer/GET_UPCOMMING_PRODUCTIONS';
export const GET_COMPOSER_WORKS = 'app/Composer/GET_COMPOSER_WORKS';
export const GET_COMPOSER_IMAGES = 'app/Composer/GET_COMPOSER_IMAGES';
export const GET_COMPOSER_VIDEOS = 'app/Composer/GET_COMPOSER_VIDEOS';
export const GET_COMPOSER_PRODUCTIONS = 'app/Composer/GET_COMPOSER_PRODUCTIONS';
export const GET_COMPOSER_REVIEWS = 'app/Composer/GET_COMPOSER_REVIEWS';
